/**
 * API_CODE 外链渲染:按 code 形态判 Jira / Case-Flow 跳转目标。
 *
 * - `XX-\d+`(2+ 位项目前缀 + 短横 + 全数字,如 DC-4145326 / PNC-123) → Jira browse
 * - 其余(LPL0000239532 / AIP1234 等) → Case-Flow (waypulse), 按 region 路由:
 *   * cn (国内, 默认) → https://waypulse.brood.neolix.cn/
 *   * ae (阿联酋) → https://waypulse.neolixgo.ai/
 *   * sea (新加坡) → https://waypulse.neolix.ai/
 * - 空值 → 灰色占位符
 *
 * region 取自 scene_inspection.region, 由 case_flow_service.create_scene 落库时按 record_address
 * 里 Azure account host 派生, sync 完成后 record_address 会改成国内 BOS 路径, 因此不能靠 record_address 判 region.
 */
import type { CSSProperties } from 'react';

const JIRA_BROWSE_PREFIX = 'https://jira.neolix.net/browse/';
const CASE_FLOW_BROWSE_PREFIX_CN = 'https://waypulse.brood.neolix.cn/?case=';
const CASE_FLOW_BROWSE_PREFIX_AE = 'https://waypulse.neolixgo.ai/?case=';
const CASE_FLOW_BROWSE_PREFIX_SEA = 'https://waypulse.neolix.ai/?case=';
const JIRA_CODE_PATTERN = /^[A-Za-z]{2,}-\d+$/;

const emptyStyle: CSSProperties = { color: '#9b9da3' };

function pickCaseFlowPrefix(region?: string | null): string {
  switch ((region || '').toLowerCase()) {
    case 'ae': return CASE_FLOW_BROWSE_PREFIX_AE;
    case 'sea': return CASE_FLOW_BROWSE_PREFIX_SEA;
    default: return CASE_FLOW_BROWSE_PREFIX_CN;
  }
}

export default function ApiCodeLink({
  code,
  source: _source,
  region,
}: {
  code?: string | null;
  source?: string | null;
  region?: string | null;
}) {
  const value = (code || '').trim();
  if (!value) {
    return <span style={emptyStyle}>-</span>;
  }
  const isJira = JIRA_CODE_PATTERN.test(value);
  const caseFlowPrefix = pickCaseFlowPrefix(region);
  const href = isJira
    ? `${JIRA_BROWSE_PREFIX}${encodeURIComponent(value)}`
    : `${caseFlowPrefix}${encodeURIComponent(value)}`;
  const label = isJira ? 'Jira' : 'Case-Flow';
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      title={`在 ${label} 打开 ${value}`}
    >
      {value}
    </a>
  );
}
